export * from './StaticProductHeader';
